// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4871d81c","833":"3ebfd400"}[chunkId] + ".chunk.js";
};